import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';

import {
  downloadCsvTemplate,
  downloadXlsxTemplate,
} from '@services/queries/onboarding/downloadTemplate';
import { useMutation } from 'react-query';

import { NavigationContext } from '@layout/navigation/navigation';
import { useContext } from 'react';
import {
  Overlay,
  Container,
  Header,
  Title,
  Close,
  Items,
  Item,
} from './TemplateDownloadDialog.styles';

const FileConverter = (blob: BlobPart, fileName: string, fileType: string) => {
  const blobUrl = new Blob([blob], {
    type: fileType,
  });

  const fileURL = window.URL.createObjectURL(blobUrl);
  const anchorLink = document.createElement('a');
  anchorLink.href = fileURL;
  anchorLink.download = fileName;
  anchorLink.click();

  window.URL.revokeObjectURL(fileURL);
};

interface ITemplateDownloadDialog {
  open: boolean;
  onClose: () => void;
}

export const TemplateDownloadDialog = ({
  open,
  onClose,
}: ITemplateDownloadDialog) => {
  const portalDiv = document.getElementById('portal');

  const { studioId } = useContext(NavigationContext);

  const downloadCsvFileTemplate = useMutation(
    async () => {
      return downloadCsvTemplate({ studioId });
    },
    {
      onSuccess: res => {
        FileConverter(res, 'example.csv', 'text/csv;charset=utf-8;');
        onClose();
      },
    },
  );

  const downloadXlsxFileTemplate = useMutation(
    async () => {
      return downloadXlsxTemplate({ studioId });
    },
    {
      onSuccess: async res => {
        FileConverter(
          res,
          'example.xlsx',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        );
        onClose();
      },
    },
  );

  const itemList: {
    icon: any;
    label: string;
    onClick: () => void;
  }[] = [
    {
      icon: 'download',
      label: 'CSV format',
      onClick: () => {
        downloadCsvFileTemplate.mutate();
      },
    },
    {
      icon: 'download',
      label: 'Excel format',
      onClick: () => {
        downloadXlsxFileTemplate.mutate();
      },
    },
  ];

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header>
              <Title>Download Template</Title>
              <Close onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </Close>
            </Header>

            <Items>
              {itemList.map(item => (
                <Item key={item.label} onClick={item.onClick}>
                  <BlueIcon icon={item.icon} color="#8F95B2" /> {item.label}
                </Item>
              ))}
            </Items>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
